import classNames from 'classnames';
import PropTypes from 'prop-types';

const LinesIcon = ({ className }) => {
  return (
    <svg
      className={classNames('lines-icon', className)}
      width='24'
      viewBox='0 0 24 24'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M3 6H10' stroke='currentColor' strokeWidth='2.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3 12H19' stroke='currentColor' strokeWidth='2.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3 18H19' stroke='currentColor' strokeWidth='2.3' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

LinesIcon.propTypes = {
  className: PropTypes.string,
};

export default LinesIcon;
